import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';

export const initialDataResolver = () =>
{
    const navigationService = inject(NavigationService);

    // il menu dipende dal ruolo dell'utente, già caricato dalla guardia di accesso
    return forkJoin([
        navigationService.get(),
    ]);
};
